import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChangePassword, CheckEmail } from '~/components/ResetPassword';
import { Layout } from '~/components/SignUp';
import { HelmetHead } from '~/components/common';
import { ResetPasswordStep } from '~/types';
import { PAGE_ROUTE } from '~/constants';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [currentStep, setCurrentStep] =
    useState<ResetPasswordStep>('CheckEmail');

  const stepTitles: Record<string, string> = {
    CheckEmail: 'Reset your password',
    ChangePassword: 'Reset your password',
  };

  const title = stepTitles[currentStep];

  const renderStep = (stepName: ResetPasswordStep) => {
    switch (stepName) {
      case 'CheckEmail':
        return (
          <CheckEmail
            email={email}
            setEmail={setEmail}
            onNextStep={() => setCurrentStep('ChangePassword')}
          />
        );
      case 'ChangePassword':
        return (
          <ChangePassword
            email={email}
            onNextStep={() => navigate(PAGE_ROUTE.PASSWORD_SUCCESS)}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <HelmetHead title='Reset Password' />
      <Layout title={title}>{renderStep(currentStep)}</Layout>
    </>
  );
}
